import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import { useState } from "react";
import { Snackbar, Alert } from "@mui/material";

function DOBField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid date of birth provided.");

  function calculateAge(birthday) {
    // birthday is a date
    const ageDifMs = Date.now() - birthday;
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  return (
    <MDBox>
      <MDInput
        name={fieldRef}
        id={`dff_${fieldRef}`}
        margin="dense"
        label={displayName}
        type="date"
        fullWidth
        variant="outlined"
        onBlur={(e) => {
          const dob = e.target.value;
          const dobDate = new Date(dob);
          const age = calculateAge(dobDate);
          let ageMin = 0;
          if (typeof options.min_age === "undefined") {
            ageMin = 18;
          } else {
            ageMin = options.min_age;
          }

          if (age < ageMin) {
            e.target.value = null;
            setErrMsg(`A minimum age of ${ageMin} is required`);
            showFieldError(true);
            return;
          }

          if (typeof options.max_age !== "undefined") {
            if (age > options.max_age) {
              e.target.value = null;
              setErrMsg(`A maximum age of ${options.max_age} is required`);
              showFieldError(true);
            }
          }
        }}
        options={options}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
    </MDBox>
  );
}

// Typechecking props of the Transaction
DOBField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

DOBField.defaultProps = {
  options: null,
};

export default DOBField;
